module.exports = __webpack_public_path__ + "assets/img/preview_04.7b65095a.png";